module.exports = __webpack_public_path__ + "img/1508043979.9b148f3a.jpg";